import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import { cn } from '@/utils';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ asChild, variant = 'primary', className, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button'; // 默认使用 `button`，否则用 `Slot`

  return (
    <Comp
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center px-4 py-2 rounded text-sm font-medium transition',
        {
          'bg-blue-500 text-white hover:bg-blue-600': variant === 'primary',
          'bg-gray-200 text-gray-800 hover:bg-gray-300': variant === 'secondary',
          'bg-red-500 text-white hover:bg-red-600': variant === 'danger',
        },
        className,
      )}
      {...props}
    />
  );
});
